<template>
  <div :class="[$b(), `product-banner ${pageMode}`]">
    <div :class="$b('wrapper')">
      <VisionLink
        v-for="link in links"
        :key="link.target"
        :to="resolveLocalePath(link.target)"
        display="inline-block"
        @mouseover="activeTarget = link.target"
        @mouseleave="activeTarget = ''"
      >
        <div class="product-banner-block-cont">
          <div>
            <VisionIcon
              :key="link.target"
              :icon="link.icon"
              :colour="activeTarget ? 'none' : 'black'"
              :gradient="activeTarget === link.target ? 'default' : 'none'"
              size="stretch"
              :class="$b('icon')"
            />
            <h5>
              {{ $tr(link.name) }}
            </h5>
            <p
              :class="`${link.subtitleClass || ''} ${
                !link.subtitle ? 'trans' : ''
              }`"
              :style="{ color: link.subtitleColour }"
            >
              {{ link.subtitle ? $tr(link.subtitle) : '&nbsp;' }}
            </p>
          </div>
        </div>
      </VisionLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SplitterBanner',

  props: {
    pageMode: { type: String, default: '' },
    linksOverride: { type: Array, default: () => [] },
  },

  setup () {
    const { resolveLocalePath } = useUrlBuilder()
    return { resolveLocalePath }
  },

  data() {
    return {
      activeTarget: '',
    }
  },

  computed: {
    links() {
      if (this.linksOverride.length) return this.linksOverride

      if (this.pageMode === 'goggles') {
        // Goggles links
        return [
          {
            target: '/shop/goggles/vanguards',
            icon: 'vanguards',
            name: 'Vanguards™',
            subtitle: 'Bestseller',
            subtitleClass: 'orange',
          },
          {
            target: '/shop/goggles/ullrs',
            icon: 'ullrs',
            name: 'Ullrs™',
            subtitle: 'New'
          },
          {
            target: '/shop/goggles/snipers',
            icon: 'snipers',
            name: 'Snipers™'
          },
          {
            target: '/shop/parts',
            icon: 'sniperslens',
            name: 'Lenses & Parts',
          },
          {
            target: '/shop/cases/snowcapsule',
            icon: 'gogglecapsule',
            name: 'Cases',
          },
        ]
      } else if (this.pageMode === 'pace') {
        // Pace links
        return [
          {
            target: '/shop/sunglasses/vulcans',
            icon: 'vulcans',
            name: 'Vulcans™',
          },
          {
            target: '/shop/sunglasses/gts',
            icon: 'gts',
            name: 'GTs™',
            subtitle: 'New',
          },
          {
            target: '/shop/sunglasses/airas',
            icon: 'airas',
            name: 'Airas™',
          },
          {
            target: '/shop/sunglasses/ultras',
            icon: 'ultras',
            name: 'Ultras™',
          },
          {
            target: '/shop/sunglasses/velans',
            icon: 'velans',
            name: 'Velans™',
          },
          {
            target: '/shop/sunglasses/tempests',
            icon: 'tempests',
            name: 'Tempests™',
            subtitle: 'New',
          },
          {
            target: '/shop/parts/pace',
            icon: 'vcle-ff',
            name: 'Lenses & Parts',
          },
          {
            target: '/shop/cases/pacecapsule',
            icon: 'sunglassescapsule',
            name: 'Cases',
          },
        ]
      } else if (this.pageMode === 'sunglasses') {
        return [
          {
            target: '/shop/sunglasses/renegades',
            icon: 'renegades',
            name: 'Renegades™',
            subtitle: 'Bestseller',
            subtitleClass: 'orange',
          },
          {
            target: '/shop/sunglasses/tokas',
            icon: 'tokas',
            name: 'Tokas™',
            subtitle: 'New',
          },
          {
            target: '/shop/sunglasses/sierras',
            icon: 'sierras',
            name: 'Sierras™',
          },
          {
            target: '/shop/sunglasses/zephyrs',
            icon: 'zephyrs',
            name: 'Zephyrs™',
          },
          {
            target: '/shop/sunglasses/classics3',
            icon: 'classics3',
            name: 'Classics³',
          },
          {
            target: '/shop/sunglasses/tempests',
            icon: 'tempests',
            name: 'Tempests™',
          },
          {
            target: '/shop/sunglasses/vulcans',
            icon: 'vulcans',
            name: 'Vulcans™',
          },
          {
            target: '/shop/sunglasses/airas',
            icon: 'airas',
            name: 'Airas™',
          },
          {
            target: '/shop/sunglasses/ultras',
            icon: 'ultras',
            name: 'Ultras™',
          },
          {
            target: '/shop/sunglasses/velans',
            icon: 'velans',
            name: 'Velans™',
          },
          {
            target: '/shop/lenses',
            icon: 'vcle-ff',
            name: 'Lenses & Parts',
          },
          {
            target: '/shop/cases',
            icon: 'sunglassescapsule',
            name: 'Cases',
          },
        ]
      }

      // Sunglasses Links
      return [
        {
          target: '/shop/sunglasses/renegades',
          icon: 'renegades',
          name: 'Renegades™',
          subtitle: 'Bestseller',
          subtitleClass: 'orange',
        },
        {
          target: '/shop/sunglasses/tokas',
          icon: 'tokas',
          name: 'Tokas™',
          subtitle: 'New',
        },
        {
          target: '/shop/sunglasses/sierras',
          icon: 'sierras',
          name: 'Sierras™',
        },
        {
          target: '/shop/sunglasses/zephyrs',
          icon: 'zephyrs',
          name: 'Zephyrs™',
        },
        {
          target: '/shop/sunglasses/classics3',
          icon: 'classics3',
          name: 'Classics³',
        },
        {
          target: '/shop/sunglasses/tempests',
          icon: 'tempests',
          name: 'Tempests™',
        },
        {
          target: '/shop/lenses',
          icon: 'sle2',
          name: 'Lenses & Parts',
        },
        {
          target: '/shop/cases',
          icon: 'sunglassescapsule',
          name: 'Cases',
        },
      ]
    },
  },
}
</script>

<style lang="postcss">
.SplitterBanner__icon {
  width: 90px;
  height: 72px;
  margin: auto;
  overflow: hidden;
}

.SplitterBanner__wrapper {
  @apply pt-4;
}

.product-banner {
  @apply bg-grey-light scrollbar-styled;
  text-align: left;
  overflow: auto;
  white-space: nowrap;

  a {
    -webkit-tap-highlight-color: transparent;

    &:hover,
    &:active {
      h5 {
        color: transparent;
        background-image: var(--gradient-default);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    div.product-banner-block-cont {
      display: inline-block;

      > div {
        display: inline-block;
        width: 140px;
        text-align: center;
        position: relative;

        h5 {
          font-size: 0.8em;
        }

        p {
          font-size: 0.65em;
          text-transform: uppercase;
          margin: 0;
          background-image: var(--gradient-default);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        p.orange {
          background-image: var(--gradient-orange);
        }

        p.trans {
          opacity: 0;
        }
      }
    }
  }
}

@screen md {
  .product-banner {
    text-align: center;
  }
}
</style>
